module.exports = __webpack_public_path__ + "static/media/tianying9.368358d4.png";